import React from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';

import uniqueId from '../../utils/uniqueId';

const ContextMenuWrapper = (onDeleteChild, onEdit, isSuper = false) => {
  const ContextMenuWrapped = (value, data) => {
    const id = uniqueId();
    const plainData = data.toJS();

    return (
      <div>
        <ContextMenuTrigger disable={!isSuper} id={id}>
          <div>{value}</div>
        </ContextMenuTrigger>
        <ContextMenu id={id}>
          <MenuItem data={plainData} disable={!isSuper} onClick={onEdit}>
            <i className="fa fa-pencil" /> Edit
          </MenuItem>
          <MenuItem data={plainData} disable={!isSuper} onClick={onDeleteChild}>
            <i className="fa fa-remove" /> Delete
          </MenuItem>
        </ContextMenu>
      </div>
    );
  };

  return ContextMenuWrapped;
};

export default ContextMenuWrapper;
